var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "17px",
    viewBox: "0 0 9 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UIKit",
    transform: "translate(-565.000000, -823.000000)",
    fill: "#859599",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(530.000000, 750.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Facebook",
    transform: "translate(28.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.625,20 L9.625,12.3964844 L7,12.3964844 L7,9.375 L9.625,9.375 L9.625,6.984375 C9.625,5.72265625 9.98863654,4.74316406 10.7159091,4.04589844 C11.4431816,3.34863281 12.4090911,3 13.6136364,3 C14.5909093,3 15.3863636,3.04427066 16,3.1328125 L16,5.82226562 L14.3636364,5.82226562 C13.75,5.82226562 13.3295456,5.95507812 13.1022727,6.22070312 C12.9204547,6.44205746 12.8295455,6.79622379 12.8295455,7.28320312 L12.8295455,9.375 L15.7272727,9.375 L15.3181818,12.3964844 L12.8295455,12.3964844 L12.8295455,20 L9.625,20 Z",
    id: "\\uF39E"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ac14198b.svg";
export { ForwardRef as ReactComponent };